import { FunctionComponent } from 'react';
import { BodyText, Div, Flex, Gutter, Icon } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

export const PortalMaintenanceNotification: FunctionComponent = () => {
  const { t } = useTranslation('frontPage');

  return (
    <Div backgroundColor={'white'} padding={{ size: 'sm' }} data-testid="portal-maintenance-notification" role="status">
      <Flex margin={{ top: 'xxs' }}>
        <Icon name="info-filled" size="sm" color={'blue600'} margin={{ top: 'xxxs' }} />
        <Gutter size={'sm'} />
        <Flex wrapContent occupyHorizontalSpace>
          <BodyText tagName="span" margin={{ right: 'md', bottom: 'xxs' }} fontWeight={'medium'} size={'sm'} color="black">
            {t('portalMaintenanceNotification.title')}
          </BodyText>
          <BodyText tagName="span" size={'sm'} color={'gray700'}>
            {t('portalMaintenanceNotification.message')}
          </BodyText>
        </Flex>
      </Flex>
    </Div>
  );
};
